import { useTranslation } from 'react-i18next';
import { SupportEmailRequestStatus } from '../types/support-email-request.types';

type Props = { status: SupportEmailRequestStatus };

const SupportEmailRequestStatusBadge = ({ status }: Props) => {
    const { t } = useTranslation();

    const getStatusNameAndColor = (): [string, string] => {
        switch (status) {
            case SupportEmailRequestStatus.New:
                return ['supportEmailRequests.status.new', 'bg-status-new'];
            case SupportEmailRequestStatus.Ongoing:
                return ['supportEmailRequests.status.ongoing', 'bg-status-outgoing'];
            case SupportEmailRequestStatus.Done:
                return ['supportEmailRequests.status.done', 'bg-status-completed'];
            case SupportEmailRequestStatus.Cancelled:
                return ['supportEmailRequests.status.cancelled', 'bg-status-canceled'];
            case SupportEmailRequestStatus.NotRelevant:
                return ['supportEmailRequests.status.notRelevant', 'bg-gray-400'];
            default:
                return ['supportEmailRequests.status.unknown', 'bg-gray-500'];
        }
    };

    const [statusKey, dotClass] = getStatusNameAndColor();

    return (
        <div className="flex flex-row items-center justify-start gap-2">
            <div className={`h-3 w-3 rounded-full ${dotClass}`} />
            <span className="text-sm text-gray">{t(statusKey)}</span>
        </div>
    );
};

export default SupportEmailRequestStatusBadge;
